<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>录入期刊抽印本</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="共识题目" required>
          <el-col :span="11">
            <el-input
              v-model="form.name"
              placeholder="请输入共识题目"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="牵头专家" required>
          <el-col :span="6">
            <el-select
              v-model="value3"
              remote
              multiple
              filterable
              placeholder="请选择是否准备PPT"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :remote-method="remoteMethod"
              >
              </el-option>
              <!-- 这里边再加一个分页 -->
              <el-pagination small layout="prev, pager, next" :total="50">
              </el-pagination>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="目标期刊" required>
          <el-col :span="5">
            <el-input
              v-model="form.name"
              placeholder="请输入目标期刊"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊类型" required>
          <!-- 这里是上传文件 -->
          <el-radio-group v-model="radio">
            <el-radio :label="3">整篇</el-radio>
            <el-radio :label="6">整期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抽印册数" required>
          <!-- 这里是上传文件 -->
          <el-col :span="11">
            <el-input
              v-model="form.name"
              placeholder="请输入共识题目"
            ></el-input>
          </el-col>
        </el-form-item>
        <!-- 上传logo -->
        <el-form-item label="广告" required>
          <el-col :span="11">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 制作规格 -->
        <el-form-item label="制作规格" required>
          <el-col :span="11">
            <el-input
              v-model="form.name"
              placeholder="请输入制作规格"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="配送地址" required>
          <el-col :span="24">
            <el-input
              v-model="form.name"
              placeholder="请输入配送地址"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="快递单号" required>
          <el-col :span="24">
            <el-input
              v-model="form.name"
              placeholder="请输入快递单号"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系人" required>
          <el-col :span="11">
            <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="电话" required>
          <el-col :span="11">
            <el-input v-model="form.name" placeholder="请输入电话"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="邮件" required>
          <el-col :span="11">
            <el-input v-model="form.name" placeholder="请输入邮箱"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信号" required>
          <el-col :span="11">
            <el-input v-model="form.name" placeholder="请输入微信号"></el-input>
          </el-col>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注" required>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.textarea"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #484c7f"
            @click="onSubmit"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'editorProject',
  data () {
    return {
      form: {
        name: '',
        textarea: ''
      },
      // 选择框
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      // 搜索专家
      loading: false,
      // 参会专家
      value3: ['选项4', '选项3'],
      // 上传图片
      imageUrl: '',
      radio: 3
    }
  },
  updated () {
    console.log(this.value3)
  },
  methods: {
    // 点击提交表单
    onSubmit () {
      console.log('submit!')
    },
    backProject () {
      this.$router.push('/')
    },
    // 接口搜索的方法
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    }
    // 上传图片结束
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }
  /deep/.el-select {
    display: block;
  }
  // 上传图片的样式
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    width: 66px;
    height: 66px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30px;
    height: 30px;
    line-height: 66px;
    text-align: center;
  }
  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }
  // 上传图片样式结束
}
</style>
